"use client";

import Cookie from "js-cookie";
import { useRouter } from "next/navigation";

import styles from "./PrerenderBypassMode.module.scss";

export function PrerenderBypassMode() {
  const router = useRouter();
  const hasPrerenderBypassCookie = Boolean(Cookie.get("__prerender_bypass"));

  if (!hasPrerenderBypassCookie) {
    return null;
  }

  return (
    <div className={styles.prerenderByPassMode}>
      <p>You are in prerender bypass mode</p>
      <button
        onClick={() => {
          Cookie.remove("__prerender_bypass");
          router.refresh();
        }}
      >
        Exit
      </button>
    </div>
  );
}
